<template>
  <v-snackbar
    v-model="snackbar"
    :top="$vuetify.breakpoint.mdAndUp"
    :right="$vuetify.breakpoint.mdAndUp"
    :bottom="$vuetify.breakpoint.smAndDown"
    :timeout="timeout"
    :color="getSnackBarColor"
    class="app-snap"
    multi-line
  >

    {{ getSnackBarText }}

    <v-progress-linear
      :active="true"
      :value="countdownPercent"
      absolute
      bottom
      :color="`accent`"
    ></v-progress-linear>

  </v-snackbar>

</template>
<style>
  .app-snap .v-snack__content {
    position: relative;
  }
</style>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      timeout: 8000,
      countdownPercent: 100
    }
  },
  watch: {
    'snackbar'() {
      if (this.snackbar === true) {
        this.runCountdown()
      }
    }
  },
  methods: {
    runCountdown() {
      this.countdownPercent = 100
      const interval = 100 // milliseconds
      // Doing -500 here because there is a bit of time before the value in the state propagates
      // up to the watcher of this component. 500 is arbitrary, but it seems to be good enough.
      let timeleft = this.timeout - 500

      const downloadTimer = setInterval(() => {
        if (timeleft <= 0) {
          clearInterval(downloadTimer)
        }

        timeleft -= interval

        this.countdownPercent = Math.round(timeleft / this.timeout * 100)

      }, interval)
    },
  },
  computed: {
    ...mapGetters([
      'getSnackBarColor',
      'getSnackBarText'
    ]),
    snackbar: {
      get() {
        return this.$store.state.snackbar.isVisible
      },
      set(val) {
        this.$store.commit('updateVisibility', val)
      }
    }
  }
}
</script>
